import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import {
  ProductSeparatedWithTypes,
  ProductToSeparate,
  SeparatedProduct,
} from "./types";

const getProductsSeparatedWithTypes = (
  products: ProductToSeparate[],
  separated: SeparatedProduct[]
): ProductSeparatedWithTypes[] =>
  isArrayHasItems(separated)
    ? separated.map(({ payment_settings: paymentSettings, sku }) => {
        const productCurrent = products.find((product) => product.sku === sku);

        const paymentSettingsWithTypes =
          productCurrent && paymentSettings
            ? paymentSettings.map(({ code, value }) => {
                const currentPaymentMethod =
                  productCurrent.payment_settings.find(
                    (method) => method.code === code
                  );
                return {
                  code,
                  value,
                  type: currentPaymentMethod?.type,
                };
              })
            : [];

        return {
          sku,
          payment_settings: paymentSettingsWithTypes,
        };
      })
    : [];

export default getProductsSeparatedWithTypes;
